import React from 'react';
import Text from './Text.js';
import Bubble from './Bubble.js';
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';

/**
 * @param classes
 * @param first
 * @param second
 * @param handleChange
 * @param onBlur
 * @param third
 * @param text
 * @param isToggle
 * @param allowToggleOff
 * @param disabled
 * @returns {*}
 * @constructor
 */
const BubbleSelectBlock = ({
  customStyle = {},
  first,
  second,
  handleChange,
  onBlur,
  third = {
    selected: false
  },
  text = i18n.t(tokens.labels.or),
  isToggle = true,
  allowToggleOff = false,
  disabled = false,
  label = false
}) => {
  const selectBlock = {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...selectBlock,
      ...customStyle
    }
  }, label && /*#__PURE__*/React.createElement(Text, {
    small: true,
    margin: "0 5px"
  }, label), /*#__PURE__*/React.createElement(Bubble, {
    disabledHover: disabled,
    label: first.title,
    isSelected: first.selected,
    onBlur: onBlur,
    customStyle: first.customStyle,
    clickable: !disabled,
    rightIcon: first.rightIcon,
    onClickRightIcon: first.onClickRightIcon,
    onClick: () => {
      if (disabled) {
        return null;
      }
      if (!isToggle) {
        handleChange(first.field, false);
        return null;
      }
      if (first.selected && !second.selected && !third.selected) {
        if (allowToggleOff) {
          handleChange(first.field, false);
        }
        return null;
      }
      if (second.selected) {
        handleChange(second.field, false);
      }
      if (third.selected) {
        handleChange(third.field, false);
      }
      handleChange(first.field, !first.selected);
      return null;
    }
  }), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    margin: "0 10px"
  }, text), /*#__PURE__*/React.createElement(Bubble, {
    disabledHover: disabled,
    label: second.title,
    isSelected: second.selected,
    onBlur: onBlur,
    customStyle: second.customStyle,
    clickable: !disabled,
    onClick: () => {
      if (disabled) {
        return null;
      }
      if (!isToggle) {
        handleChange(second.field, false);
        return null;
      }
      if (second.selected && !first.selected && !third.selected) {
        if (allowToggleOff) {
          handleChange(second.field, false);
        }
        return null;
      }
      if (first.selected) {
        handleChange(first.field, false);
      }
      if (third.selected) {
        handleChange(third.field, false);
      }
      handleChange(second.field, !second.selected);
      return null;
    }
  }), third.title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    margin: "0 10px"
  }, i18n.t(tokens.labels.or)), /*#__PURE__*/React.createElement(Bubble, {
    disabledHover: disabled,
    label: third.title,
    isSelected: third.selected,
    onBlur: onBlur,
    customStyle: third.customStyle,
    clickable: !disabled,
    onClick: () => {
      if (disabled) {
        return null;
      }
      if (!isToggle) {
        handleChange(third.field, false);
        return null;
      }
      if (third.selected && !first.selected && !second.selected) {
        if (allowToggleOff) {
          handleChange(third.field, false);
        }
        return null;
      }
      if (first.selected) {
        handleChange(first.field, false);
      }
      if (second.selected) {
        handleChange(second.field, false);
      }
      handleChange(third.field, !third.selected);
      return null;
    }
  })));
};
export default BubbleSelectBlock;